import { Component, OnInit } from '@angular/core';
import { ShopService } from 'src/app/services/shop.service';
import { NavigationService } from 'src/app/services/navigation.service';

@Component({
  selector: 'app-delivery-address',
  templateUrl: './delivery-address.component.html',
  styleUrls: ['./delivery-address.component.scss']
})
export class DeliveryAddressComponent implements OnInit {

  hasStreetNumber = true;
  outOfDeliveryArea = false;

  constructor(
    private shop: ShopService,
    private nav: NavigationService
  ) { }

  ngOnInit() {
  }

  onAutocompleteSelected(event) {
    this.outOfDeliveryArea = false;
    // check if streetNumber is present
    let hasStreetNumber = false;
    event.address_components.forEach(
      (address) => {
        if (address.types[0] === 'street_number') {
          hasStreetNumber = true;
        }
      }
    );
    this.hasStreetNumber = hasStreetNumber;
    if (!hasStreetNumber) {
      return; // cancel if no streetNumber present
    }
    this.shop.getDeliveryZoneInfoByGooglePlaces(event).subscribe(
      (res) => {
        this.shop.restaurants.value.forEach((r) => {
          if (r.restaurantId === res.restaurantId) {

            this.shop.orderType.next('delivery');
            const sq = JSON.parse(JSON.stringify(this.nav.shopQueryParams.value));
            sq.restaurantId = res.restaurantId;
            sq.orderType = 'delivery';
            sq.col1 = 'categories';
            this.nav.shopQueryParams.next(sq);
            this.shop.restaurant.next(r);
          }
        });
        if (!res) {
          this.outOfDeliveryArea = true;
        }
      }
    );
  }
  onLocationSelected(event) {

  }

}
